module.exports = __webpack_public_path__ + "img/pending-pay.2f1a8d4e.svg";